import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./logic/rootReducer";
import { saveCart } from "./logic/localStorage";

const configureStore = () => {
  const store = createStore(
    rootReducer,
    applyMiddleware(
      thunkMiddleware,
    ),
  );

  //Persist the cart whenever it changes
  let prevCartItems = store.getState().cart.items;
  store.subscribe(() => {
    const cartItems = store.getState().cart.items;
    if (cartItems !== prevCartItems) {
      prevCartItems = cartItems;
      saveCart(cartItems);
    }
  });

  return store;
};

export default configureStore;
